export default __webpack_public_path__ + "static/cafe_36068-b0fad11db7f7a0337d929f107604509f.png";